/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
*/

const chMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  'user.login-title': 'Connexion',
  'user.register': 'S’inscrire',
  'user.forgot-password': 'Mot de passe oublié',
  'user.email': 'E-mail',
  'user.newpassword': 'Nouveau mot de passe',
  'user.currentpassword': 'Mot de passe actuel',
  'user.newpasswordagain': 'Nouveau mot de passe (à nouveau)',
  'user.password': 'Mot de passe',
  'user.forgot-password-question': 'Mot de passe oublié ?',
  'user.fullname': 'Nom complet',
  'user.firstname': 'Prénom',
  'user.lastname': 'Nom de famille',
  'user.login-button': 'CONNEXION',
  'user.register-button': 'INSCRIPTION',
  'user.reset-password-button': 'RÉINITIALISER',
  'user.buy': 'ACHETER',
  'user.username': "Nom d'utilisateur",

  /* 03.Menu */
  'menu.app': 'Accueil',

  'menu.default': 'Par défaut',
  'menu.analytics': 'Analytique',
  'menu.ecommerce': 'E-commerce',
  'menu.content': 'Contenu',
  'menu.pages': 'Pages',
  'menu.data-list': 'Liste de données',
  'menu.thumb-list': 'Liste avec vignettes',
  'menu.image-list': 'Liste d’images',
  'menu.details': 'Détails',
  'menu.search': 'Recherche',
  'menu.login': 'Connexion',
  'menu.register': 'Inscription',
  'menu.forgot-password': 'Mot de passe oublié',
  'menu.error': 'Erreur',
  'menu.applications': 'Applications',
  'menu.todo': 'Liste de tâches',
  'menu.survey': 'Sondage',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Éditer',
  'menu.alerts': 'Alertes',
  'menu.badges': 'Badges',
  'menu.buttons': 'Boutons',
  'menu.cards': 'Cartes',
  'menu.carousel': 'Carrousel',
  'menu.charts': 'Graphiques',
  'menu.collapse': 'Replier',
  'menu.dropdowns': 'Listes déroulantes',
  'menu.editors': 'Éditeurs',
  'menu.form-layouts': 'Agencements de formulaire',
  'menu.form-components': 'Composants de formulaire',
  'menu.form-validations': 'Validations de formulaire',
  'menu.icons': 'Icônes',
  'menu.input-groups': 'Groupes de champs',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modale',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Info-bulle',
  'menu.sortable': 'Triable',
  'menu.tables': 'Tableaux',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Sous-masqué',
  'menu.hidden': 'Masqué',
  'menu.visible': 'Visible',
  'menu.maps': 'Cartes',
  'menu.landingpage': 'Page d’atterrissage',
  'menu.multipage-home': 'Accueil multipage',
  'menu.singlepage-home': 'Accueil une page',
  'menu.about': 'À propos',
  'menu.auth-login': 'Connexion Auth',
  'menu.auth-register': 'Inscription Auth',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Détail du blog',
  'menu.careers': 'Carrières',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Fonctionnalités',
  'menu.prices': 'Tarifs',
  'menu.videos': 'Vidéos',
  'menu.mailing': 'Courrier',
  'menu.invoice': 'Facture',
  'menu.blank-page': 'Bientôt disponible...',
  'menu.types': 'Types de menus',
  'menu.levels': 'Niveaux de menu',
  'menu.third-level-1': 'Troisième niveau 1',
  'menu.third-level-2': 'Troisième niveau 2',
  'menu.third-level-3': 'Troisième niveau 3',

  /* 04.Dashboards */
  'dashboards.update': 'Mettre à jour',
  'dashboards.save': 'Enregistrer',
  'dashboards.pending-orders': 'Commandes en attente',
  'dashboards.completed-orders': 'Commandes terminées',
  'dashboards.refund-requests': 'Demandes de remboursement',
  'dashboards.new-comments': 'Nouveaux commentaires',
  'dashboards.sales': 'Ventes',
  'dashboards.orders': 'Commandes',
  'dashboards.refunds': 'Remboursements',
  'dashboards.recent-orders': 'Commandes récentes',
  'dashboards.product-categories': 'Catégories de produits',
  'dashboards.cakes': 'Gâteaux',
  'dashboards.tickets': 'Billets',
  'dashboards.calendar': 'Calendrier',
  'dashboards.best-sellers': 'Meilleures ventes',
  'dashboards.per-session': 'Par session',
  'dashboards.profile-status': 'Statut du profil',
  'dashboards.payment-status': 'Statut du paiement',
  'dashboards.work-progress': 'Avancement du travail',
  'dashboards.tasks-completed': 'Tâches terminées',
  'dashboards.payments-done': 'Paiements effectués',
  'dashboards.order-stock': 'Commande - Stock',
  'dashboards.categories': 'Catégories',
  'dashboards.quick-post': 'Publication rapide',
  'dashboards.title': 'Titre',
  'dashboards.content': 'Contenu',
  'dashboards.connect': 'Connexion',
  'dashboards.ticket-count': 'Nombre de billets',
  'dashboards.commonticketsubmission': 'Soumissions de tickets courantes',
  'dashboards.category': 'Catégorie',
  'dashboards.save-and-publish': 'Enregistrer et publier',
  'dashboards.top-viewed-posts': 'Articles les plus vus',
  'dashboards.posts': 'Articles',
  'dashboards.pending-for-publish': 'En attente de publication',
  'dashboards.users': 'Utilisateurs',
  'dashboards.on-approval-process': 'En cours d’approbation',
  'dashboards.alerts': 'Alertes',
  'dashboards.waiting-for-notice': 'En attente d’avis',
  'dashboards.files': 'Fichiers',
  'dashboards.pending-for-print': 'En attente d’impression',
  'dashboards.logs': 'Journaux',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'LA MAGIE EST DANS LES DÉTAILS',
  'dashboards.yes-it-is-indeed': 'Oui, tout à fait !',
  'dashboards.advanced-search': 'Recherche avancée',
  'dashboards.toppings': 'Garnitures',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Mot-clé',
  'dashboards.search': 'Recherche',
  'dashboards.top-rated-items': 'Articles les mieux notés',

  'dashboards.country': 'Pays',
  'dashboards.webVisitors': 'Visiteurs Web',
  'dashboards.avatarClicks': 'Clics sur lavatar',
  'dashboards.wordCloud': 'Nuage de mots',
  'dashboards.topic': 'Topic',
  'dashboards.roomsAvailability': 'Chambres et disponibilité',
  'dashboards.startChat': 'Démarrer une discussion',
  'dashboards.restaurantsBars': 'Restaurants et bars',
  'dashboards.groupBooking': 'Réservation de groupe',
  'dashboards.promotions': 'Promotions',
  'dashboards.weedingevents': 'Mariages & Événements',
  'dashboards.lostsomething': 'Objet perdu',
  'dashboards.producttext': 'Texte du produit',
  'dashboards.bookingroomnew': 'Réserver une nouvelle chambre',
  'dashboards.email': 'E‑mail',
  'dashboards.phone': 'Téléphone',
  'dashboards.zipcode': 'Code postal',
  'dashboards.marketingconsent': 'Consentement marketing',
  'dashboards.additionalinfo': 'Informations supplémentaires',
  'dashboards.viewallcontacts': 'Voir tous les contacts',
  'dashboards.current': 'Actuel',
  'dashboards.last7days': '7 derniers jours',
  'dashboards.last30days': '30 derniers jours',
  'dashboards.thisweek': 'Cette semaine',
  'dashboards.thismonth': 'Ce mois-ci',
  'dashboards.previousmonth': 'Mois précédent',
  'dashboards.yeartodate': 'Depuis le début de l’année',
  'dashboards.lastyear': 'L’année dernière',
  'dashboards.all': 'Tous',
  'dashboards.standardOccupancy': 'Occupation standard',
  'dashboards.max-occupancy': 'Occupation maximale',
  'dashboards.numberOfThisType': 'Nombre de ce type',
  'dashboards.displayOrder': 'Ordre d\'affichage',
  'dashboards.provider': 'Fournisseur',
  'dashboards.edit': 'Modifier',
  'dashboards.delete': 'Supprimer',
  'dashboards.addImages': 'Ajouter des images',
  'dashboards.location_ip': 'Emplacement approximatif déterminé par adresse IP',
  'dashboards.near': 'Proche',
  'dashboards.referral': 'Utilisateur référé par ce site Web',
  'dashboards.calling_party': 'Appelant (partie initiatrice)',
  'dashboards.called_party': 'Partie appelée',
  'dashboards.lastdial': 'Dernier appel',
  'dashboards.imagelink': 'Lien d’image',
  'dashboards.browsegallery': 'Parcourir la galerie',
  'dashboards.changelog': 'Journal des modifications',
  'dashboards.externalresources': 'Ressources externes',
  'dashboards.webpage': 'Page Web',
  'dashboards.web-pages': 'Pages Web',
  'dashboards.published': 'Publié',
  'dashboards.adddocument': 'Ajouter un document',
  'dashboards.ready-to-publish': 'Prêt à publier',
  'dashboards.draft': 'Brouillon',
  'dashboards.order-by': 'Trier par',
  'dashboards.add-faq': 'Ajouter une FAQ',
  'dashboards.collections': 'Collections',
  'dashboards.items': 'Articles',
  'dashboards.rooms-availability': 'Chambres et disponibilité',
  'dashboards.events-wedding-venues': 'Événements et lieux de mariage',
  'dashboards.long-stay-enquiry': 'Demande de long séjour',
  'dashboards.reservation-confirmation-request': 'Demande de confirmation de réservation',
  'dashboards.modify-cancel-booking': 'Modifier ou annuler une réservation',
  'dashboards.left-something-behind': 'Objet oublié',
  'dashboards.invoice-copy': 'Copie de facture/reçu',
  'dashboards.sync': 'Synchroniser',
  'dashboards.add-web-page': 'Ajouter une page Web',
  'dashboards.sprint-title': 'Découvrez Sprint, notre automatisation révolutionnaire pour entraîner un modèle d’IA en 10× moins de temps.',
  'dashboards.sprint-description': 'Sprint travaille à vos côtés — pour libérer la créativité, optimiser la productivité et réduire drastiquement le temps nécessaire pour entraîner l’Assistant Numérique.',
  'dashboards.sprint-feature': 'La fonctionnalité Sprint est conçue pour synchroniser des connaissances provenant de sources externes, la rendant précieuse tant pour la configuration initiale que pour les mises à jour régulières des données. Lorsqu’elle est exécutée sur un système actif, Sprint modifie le Knowledge Hub en fonction de vos sources externes configurées, ce qui peut influencer directement les comportements et réponses générés par l’IA. Pour obtenir de l’aide à la configuration de Sprint, veuillez contacter notre équipe de support.',
  'dashboards.change-password': 'Changer le mot de passe',
  'dashboards.sign-out': 'Déconnexion',
  'dashboards.privacy-policy': 'Politique de confidentialité',
  'dashboards.help-center': 'Centre d’aide',
  'dashboards.switch-account': 'Changer de compte',
  'dashboards.business-settings': 'Paramètres professionnels',
  'dashboards.notifications-allowed': 'Notifications autorisées',
  'dashboards.dark-theme': 'Thème sombre',
  'dashboards.online': 'En ligne',
  'dashboards.offline': 'Hors ligne',
  'dashboards.invoice-&-payments': 'Factures et paiements',
  'dashboards.upgrade-plan': 'Mettre à niveau le plan',
  'dashboards.add-room': 'Ajouter une chambre',
  'dashboards.room-type': 'Type de chambre',
  'dashboards.room-name': 'Nom de la chambre',
  'dashboards.how-many-guests': 'Combien de personnes peuvent séjourner dans cette chambre ?',
  'dashboards.number-of-rooms-this-type': 'Nombre de chambres (de ce type)',
  'dashboards.number-of-bedrooms': 'Nombre de chambres à coucher',
  'dashboards.number-of-livingrooms': 'Nombre de salons',
  'dashboards.minimum-adults': 'Adultes minimum',
  'dashboards.maximum-adults': 'Adultes maximum',
  'dashboards.maximum-children': 'Enfants maximum',
  'dashboards.maximum-infants': 'Bébés maximum',
  'dashboards.extra-beds-allowed': 'Lits supplémentaires autorisés',
  'dashboards.booking-engine-code': 'Code du moteur de réservation',
  'dashboards.room-size': 'Taille de la chambre',
  'dashboards.balcony-area': 'Surface du balcon',
  'dashboards.unit': 'Unité',
  'dashboards.square-meters': 'Mètres carrés',



  'web-widget.title': 'Menus du widget Web pour le chatbot du site',
  /*Home page*/
  'dashboards.quickstartwithai': 'Démarrage rapide avec l’IA',
  'dashboards.fastestpathtoautomation': 'Vous êtes sur la voie la plus rapide vers l’automatisation avec les outils IA',
  'dashboards.insightsthatempower': 'Des insights qui responsabilisent',
  'dashboards.trainchatbot': 'Former le chatbot',
  'dashboards.automatewithforms': 'Automatiser avec des formulaires',
  'dashboards.inroomdigitalcompendium': 'Compendium numérique en chambre',
  'dashboards.support': 'Support',
  'dashboards.helpcenter': 'Centre d’aide',
  'dashboards.searchfaqintegrations': 'Recherchez des articles sur les FAQ courantes, les intégrations et plus encore.',
  'dashboards.asklivechat': 'Posez une question à notre équipe via le Live Chat',
  'dashboards.inroomqrcode': 'Code QR dans la chambre pour voir les informations sur la propriété et l’emplacement',
  'dashboards.customizewebwidget': 'Personnalisez et ajoutez un Widget Web à votre site avec un chatbot IA intégré',
  'dashboards.createcustomforms': 'Créez des formulaires personnalisés et recevez des notifications lorsqu’un invité soumet un formulaire',
  'dashboards.trainchatbotproperty': 'Formez le chatbot avec des informations sur votre établissement comme l’heure d’arrivée, les activités, etc.',
  'dashboards.chatbotinsights': 'Découvrez comment votre chatbot engage les invités et obtenez des statistiques comme les visiteurs du site, les questions fréquentes, et bien plus encore.',
  'dashboards.addaichatbottoyourwebsite': 'Ajoutez un Chatbot IA à votre site Web',

  /* Email Stats */
  'dashboards.thread-summary-title': 'Résumés de fil',
  'dashboards.thread-summary-subtitle': 'Résumés d’e-mails générés par l’IA',
  'dashboards.ai-replies-title': 'Réponses IA',
  'dashboards.ai-replies-subtitle': 'Réponses générées par l’IA',

  'dashboards.total-thread-summary-title': 'Nombre total de résumés de fil générés',
  'dashboards.total-ai-replies-title': 'Nombre total de réponses IA générées',
  'dashboards.total-draft-copied': 'Brouillons copiés par les utilisateurs',

  'dashboards.urgency': 'Urgence',
  'dashboards.sentiment': 'Sentiment',

  'dashboards.common-email-reasons': 'Raisons courantes des e-mails',
  'dashboards.topics-in-emails': 'Sujets dans les e-mails',

  'dashboards.email-assistant-usage': 'Utilisation de l’assistant e-mail IA',
  'dashboards.usage-by-email-address': 'Utilisation par adresse e-mail',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytique',
  'pages.title.ari': 'Disponibilités et Tarifs',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Réservations',
  'pages.title.tickets': 'Leads et Tickets',
  'pages.title.propinfo': 'Réponses',
  'pages.title.discounts': 'Réductions et Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Intégration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'AJOUTER',
  'pages.add-new-modal-title': 'Ajouter un Nouvel Élément',
  'pages.display-options': 'Options d’affichage',
  'pages.orderby': 'Trier par : ',
  'pages.product-name': 'Nom du produit',
  'pages.category': 'Catégorie',
  'pages.description': 'Description',
  'pages.status': 'Statut',
  'pages.cancel': 'Annuler',
  'pages.submit': 'Soumettre',
  'pages.delete': 'Supprimer',
  'pages.another-action': 'Autre action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'En-tête',
  'pages.details': 'DÉTAILS',
  'pages.orders': 'COMMANDES',
  'pages.rating': 'Évaluation',
  'pages.price': 'Prix',
  'pages.ingredients': 'Ingrédients',
  'pages.is-vegan': 'Végétalien',
  'pages.order-status': 'Statut de la commande',
  'pages.bake-progress': 'Progression de cuisson',
  'pages.popularity': 'Popularité',
  'pages.comments': 'Commentaires',
  'pages.error-title': 'Oups... une erreur est survenue !',
  'pages.error-code': 'Code d’erreur',
  'pages.go-back-home': 'RETOURNER À L’ACCUEIL',
  'pages.mailing-info':
    'Les modèles d’e-mail utilisent des styles en ligne et des mises en page en tableau pour un affichage optimal sur divers fournisseurs. Pour une meilleure convivialité, ils sont inclus en HTML standard avec dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Le modèle de facture existe en version avec styles en ligne utilisable hors du projet, ainsi qu’en version React.',
  'pages.react-version': 'Version React',
  'pages.inline-version': 'Version HTML avec styles en ligne',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Dites quelque chose...',

  /* 06.02.Survey */
  'survey.delete': 'Supprimer',
  'survey.edit': 'Modifier',
  'survey.add-new': 'AJOUTER',
  'survey.add-new-title': 'Ajouter un Nouveau Sondage',
  'survey.title': 'Titre',
  'survey.category': 'Catégorie',
  'survey.label': 'Étiquette',
  'survey.status': 'Statut',
  'survey.cancel': 'Annuler',
  'survey.submit': 'Soumettre',
  'survey.another-action': 'Autre action',
  'survey.display-options': 'Options d’affichage',
  'survey.orderby': 'Trier par : ',
  'survey.all-surveys': 'Tous les sondages',
  'survey.completed-surveys': 'Sondages terminés',
  'survey.categories': 'Catégories',
  'survey.active-surveys': 'Sondages actifs',
  'survey.labels': 'Étiquettes',

  /* 06.03.Todo */
  'todo.add-new': 'AJOUTER',
  'todo.add-new-title': 'Ajouter une Tâche',
  'todo.title': 'Titre',
  'todo.detail': 'Détail',
  'todo.category': 'Catégorie',
  'todo.label': 'Étiquette',
  'todo.status': 'Statut',
  'todo.cancel': 'Annuler',
  'todo.submit': 'Soumettre',
  'todo.action': 'Action',
  'todo.another-action': 'Autre action',
  'todo.display-options': 'Options d’affichage',
  'todo.orderby': 'Trier par : ',
  'todo.all-tasks': 'Toutes les tâches',
  'todo.pending-tasks': 'Tâches en attente',
  'todo.completed-tasks': 'Tâches terminées',
  'todo.categories': 'Catégories',
  'todo.labels': 'Étiquettes',


  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Alerte arrondie',
  'alert.react-notifications': 'Notifications React',
  'alert.outline': 'Contour',
  'alert.primary': 'Principal',
  'alert.secondary': 'Secondaire',
  'alert.info': 'Info',
  'alert.success': 'Succès',
  'alert.warning': 'Avertissement',
  'alert.error': 'Erreur',
  'alert.filled': 'Rempli',
  'alert.primary-text': 'Ceci est une alerte principale – vérifiez !',
  'alert.secondary-text': 'Ceci est une alerte secondaire – vérifiez !',
  'alert.success-text': 'Ceci est une alerte de succès – vérifiez !',
  'alert.danger-text': 'Ceci est une alerte de danger – vérifiez !',
  'alert.warning-text': 'Ceci est une alerte d’avertissement – vérifiez !',
  'alert.info-text': 'Ceci est une alerte d’info – vérifiez !',
  'alert.light-text': 'Ceci est une alerte légère – vérifiez !',
  'alert.dark-text': 'Ceci est une alerte sombre – vérifiez !',
  'alert.default': 'Alerte par défaut',
  'alert.dismissing': 'Alerte avec fermeture',
  'alert.dismissing-text':
    'Sainte guacamole ! Vous devriez vérifier certains des champs ci-dessous.',
  'alert.dismissing-without-animate-text':
    'Je suis une alerte et je peux être fermée sans animation !',

  /* 07.02.Badges */
  'badge.sizes': 'Tailles',
  'badge.colors': 'Couleurs',
  'badge.outline': 'Contour',
  'badge.links': 'Liens',
  'badge.counter-badges': 'Badges compteur',
  'badge.bootstrap-default': 'Bootstrap par défaut',
  'badge.primary': 'Principal',
  'badge.secondary': 'Secondaire',
  'badge.success': 'Succès',
  'badge.danger': 'Danger',
  'badge.warning': 'Avertissement',
  'badge.info': 'Info',
  'badge.light': 'Clair',
  'badge.dark': 'Sombre',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap par défaut',
  'button.colors': 'Couleurs',
  'button.rounded': 'Arrondi',
  'button.outline': 'Contour',
  'button.states': 'États',
  'button.sizes': 'Tailles',
  'button.button-groups': 'Groupes de boutons',
  'button.large-button': 'Bouton grand',
  'button.small-button': 'Petit bouton',
  'button.extra-small-button': 'Très petit bouton',
  'button.block-button': 'Bouton bloc',
  'button.active': 'Actif',
  'button.disabled': 'Désactivé',
  'button.basic': 'Basique',
  'button.toolbar': 'Barre d’outils',
  'button.nesting': 'Imbrication',
  'button.vertical-variation': 'Variation verticale',
  'button.checkbox-radio-button': 'Case à cocher et bouton radio',
  'button.checkbox': 'Case à cocher',
  'button.radio': 'Radio',
  'button.radio-button': 'Bouton radio',
  'button.primary': 'Principal',
  'button.secondary': 'Secondaire',
  'button.success': 'Succès',
  'button.danger': 'Danger',
  'button.warning': 'Avertissement',
  'button.info': 'Info',
  'button.light': 'Clair',
  'button.dark': 'Sombre',
  'button.states-text':
    'Ce bouton affiche un indicateur de chargement pendant 2 secondes puis une icône d’erreur pendant 3 secondes avant de revenir à l’état normal.',
  'button.click-here': 'Cliquez ici',
  'button.states-text-alternate':
    'Ce bouton affiche un indicateur de chargement pendant 2 secondes puis une icône d’erreur pendant 3 secondes avant de revenir à l’état normal.',
  'button.primary-link': 'Lien principal',
  'button.link': 'Lien',
  'button.primary-button': 'Bouton principal',
  'button.button': 'Bouton',
  'button.left': 'Gauche',
  'button.middle': 'Milieu',
  'button.right': 'Droite',
  'button.dropdown': 'Menu déroulant',
  'button.dropdown-link': 'Lien déroulant',

  /* 07.04.Cards */
  'cards.icon-card': 'Carte avec icône',
  'cards.image-card': 'Carte avec image',
  'cards.image-overlay-card': 'Carte image superposée',
  'cards.image-card-list': 'Liste de cartes avec image',
  'cards.tab-card': 'Carte avec onglets',
  'cards.user-card': 'Carte utilisateur',

  /* 07.05.Carousel */
  'carousel.basic': 'Carrousel de base',
  'carousel.single': 'Carrousel simple',
  'carousel.without-controls': 'Carrousel sans contrôles',

  /* 07.06.Charts */
  'charts.line': 'Graphique en ligne',
  'charts.polar': 'Graphique polaire',
  'charts.area': 'Graphique de surface',
  'charts.scatter': 'Nuage de points',
  'charts.bar': 'Diagramme en barres',
  'charts.radar': 'Radar',
  'charts.pie': 'Camembert',
  'charts.doughnut': 'Graphique en anneau',
  'charts.shadow': 'Ombre',
  'charts.no-shadow': 'Sans ombre',

  /* 07.07.Collapse */
  'collapse.basic': 'Basique',
  'collapse.toggle': 'Basculer',
  'collapse.accordion': 'Accordéon',
  'collapse.controlled': 'Contrôlé',
  'collapse.uncontrolled': 'Non contrôlé',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basique',
  'dropdowns.controlled': 'Contrôlé',
  'dropdowns.uncontrolled': 'Non contrôlé',
  'dropdowns.dropdown': 'Menu déroulant',
  'dropdowns.header': 'En-tête',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Autre action',
  'dropdowns.right': 'Droite',
  'dropdowns.left': 'Gauche',
  'dropdowns.drop-directions': 'Directions du menu',
  'dropdowns.dropright': 'Menu vers la droite',
  'dropdowns.dropleft': 'Menu vers la gauche',
  'dropdowns.small-button': 'Petit bouton',
  'dropdowns.large-button': 'Grand bouton',
  'dropdowns.sizing': 'Taille',
  'dropdowns.split-button': 'Menu bouton divisé',
  'dropdowns.dropup': 'Menu vers le haut',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bulle',

  /* 07.10.Forms */
  'forms.basic': 'Basique',
  'forms.email': 'E-mail',
  'forms.email-muted': 'Votre email ne sera jamais partagé.',
  'forms.password': 'Mot de passe',
  'forms.submit': 'Soumettre',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Boutons radio',
  'forms.first-radio': 'Premier bouton',
  'forms.second-radio': 'Deuxième bouton',
  'forms.third-radio-disabled': 'Troisième désactivé',
  'forms.checkbox': 'Case à cocher',
  'forms.signin': 'Connexion',
  'forms.top-labels-over-line': 'Étiquettes en haut',
  'forms.tags': 'Étiquettes',
  'forms.date': 'Date',
  'forms.state': 'État',
  'forms.top-labels-in-input': 'Étiquettes dans le champ',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'MOT DE PASSE',
  'forms.tags-u': 'ÉTIQUETTES',
  'forms.date-u': 'DATE',
  'forms.state-u': 'ÉTAT',
  'forms.grid': 'Grille de formulaire',
  'forms.address': 'Adresse',
  'forms.address2': 'Adresse 2',
  'forms.city': 'Ville',
  'forms.city-message': 'Veuillez sélectionner une ville !',
  'forms.state-message': 'Veuillez sélectionner un état !',
  'forms.zip': 'Code postal',
  'forms.signup': 'Inscription',
  'forms.inline': 'En ligne',
  'forms.validation-availity': 'Validation Reactstrap Availity',
  'forms.validation-formik': 'Validation Formik',
  'forms.default': 'Par défaut',
  'forms.firstname': 'Prénom',
  'forms.firstname-message': 'Veuillez entrer votre prénom !',
  'forms.lastname': 'Nom de famille',
  'forms.lastname-message': 'Veuillez entrer votre nom de famille !',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Champs personnalisés',
  'form-components.checkboxes': 'Cases à cocher',
  'form-components.radios': 'Boutons radio',
  'form-components.inline': 'En ligne',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'État unique',
  'form-components.state-multiple': 'États multiples',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Sélecteur de date',
  'form-components.date': 'Date',
  'form-components.date-range': 'Plage de dates',
  'form-components.date-with-time': 'Date avec heure',
  'form-components.embedded': 'Intégré',
  'form-components.dropzone': 'Zone de dépôt',
  'form-components.drop-files-here': 'Déposez vos fichiers ici',
  'form-components.tags': 'Étiquettes',
  'form-components.switch': 'Interrupteur',
  'form-components.primary': 'Principal',
  'form-components.secondary': 'Secondaire',
  'form-components.primary-inverse': 'Principal inversé',
  'form-components.secondary-inverse': 'Secondaire inversé',
  'form-components.slider': 'Curseur',
  'form-components.double-slider': 'Curseur double',
  'form-components.single-slider': 'Curseur simple',
  'form-components.rating': 'Évaluation',
  'form-components.interactive': 'Interactif',
  'form-components.readonly': 'Lecture seule',
  'form-components.type-a-cake': 'Tapez un gâteau',
  'form-components.start': 'Début',
  'form-components.end': 'Fin',
  'form-components.tables': 'Tableaux',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Icônes Simple Line',
  'icons.iconsmind': 'Icônes Iconsmind',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basique',
  'input-groups.sizing': 'Dimensionnement',
  'input-groups.small': 'Petit',
  'input-groups.default': 'Par défaut',
  'input-groups.large': 'Grand',
  'input-groups.checkboxes-and-radios': 'Cases à cocher et radios',
  'input-groups.multiple-inputs': 'Entrées multiples',
  'input-groups.first-and-last-name': 'Prénom et nom',
  'input-groups.multiple-addons': 'Add-ons multiples',
  'input-groups.button-addons': 'Boutons add-ons',
  'input-groups.button': 'Bouton',
  'input-groups.buttons-with-dropdowns': 'Boutons avec menus déroulants',
  'input-groups.dropdown': 'Menu déroulant',
  'input-groups.header': 'En-tête',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Autre action',
  'input-groups.custom-select': 'Sélection personnalisée',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choisissez...',
  'input-groups.custom-file-input': 'Entrée fichier personnalisée',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Bonjour, le monde !',
  'jumbotron.lead':
    'Ceci est une unité de héros simple, un composant de style jumbotron pour attirer l’attention sur un contenu ou une information.',
  'jumbotron.lead-detail':
    'Utilise des classes utilitaires pour la typographie et l’espacement dans un conteneur plus large.',
  'jumbotron.learn-more': 'En savoir plus',

  /* 07.15.Modal */
  'modal.basic': 'Basique',
  'modal.modal-title': 'Titre du modal',
  'modal.launch-demo-modal': 'Lancer la démo',
  'modal.scrolling-long-content': 'Contenu long défilant',
  'modal.backdrop': 'Fond',
  'modal.backdrop-value': 'Valeur de fond',
  'modal.right-modal': 'Modal à droite',
  'modal.launch-right-modal': 'Lancer modal à droite',
  'modal.nested-modal': 'Modal imbriqué',
  'modal.size': 'Taille',
  'modal.launch-large-modal': 'Lancer grand modal',
  'modal.launch-small-modal': 'Lancer petit modal',

  /* 07.16.Navigation */
  'nav.basic': 'Navigation de base',
  'nav.active': 'Actif',
  'nav.disabled': 'Désactivé',
  'nav.disabled-link': 'Lien désactivé',
  'nav.link': 'Lien',
  'nav.longer-link': 'Lien de navigation plus long',
  'nav.another-link': 'Autre lien',
  'nav.right': 'Droite',
  'nav.dropdown': 'Menu déroulant',
  'nav.header': 'En-tête',
  'nav.action': 'Action',
  'nav.another-action': 'Autre action',
  'nav.horizontal-alignment': 'Alignement horizontal de la navigation',
  'nav.vertical-alignment': 'Alignement vertical de la navigation',
  'nav.pills': 'Navigation en pilules',
  'nav.fill-justify': 'Remplir et justifier la navigation',
  'nav.pills-dropdowns': 'Pilules avec menus déroulants',
  'nav.pagination-basic': 'Pagination de base',
  'nav.pagination-sizing': 'Dimensionnement de la pagination',
  'nav.large': 'Grand',
  'nav.small': 'Petit',
  'nav.center': 'Centre',
  'nav.pagination-alignment': 'Alignement de la pagination',
  'nav.breadcrumb-basic': 'Fil d’Ariane de base',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Info-bulle (Popover)',
  'popover-tooltip.tooltip': 'Infobulle (Tooltip)',

  /* 07.18.Sortable */
  'sortable.columns': 'Tri des colonnes',
  'sortable.basic': 'Basique',
  'sortable.handles': 'Poignées',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Tableaux Bootstrap',
  'table.bootstrap-basic': 'Tableau de base',
  'table.bootstrap-striped': 'Lignes alternées',
  'table.bootstrap-bordered': 'Tableau avec bordures',
  'table.bootstrap-borderless': 'Tableau sans bordures',
  'table.bootstrap-hoverable': 'Lignes survolables',
  'table.bootstrap-responsive': 'Tableau réactif',
  'table.react-tables': 'Tableaux React',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Défilement',
  'table.react-advanced': 'Filtre, longueur et saut',

  /* Property Info */
  "property-info.allcustomers": 'Tous les clients',
  'property-info.external-sources': 'Sources externes',
  'property-info.faq': 'FAQ',
  'property-info.documents': 'Documents',
  'property-info.publish-ai': "Publier avec l'IA",
  'property-info.pre-built-templates': 'Modèles prédéfinis',
  'property-info.room-types': 'Types de chambres',

  'property-info.about-property': 'À propos de la propriété',
  'property-info.about-properties': 'À propos des propriétés',
  'property-info.facilities-services': 'Installations et services',
  'property-info.property-facilities': 'Installations de la propriété',
  'property-info.room-amenities': 'Commodités de la chambre',
  'property-info.property-contact': 'Contact de la propriété',
  'property-info.property-activities': 'Activités immobilières',
  'property-info.property-location': 'Emplacement de la propriété',
  'property-info.about-rooms': 'À propos des chambres',
  'property-info.about-sites': 'À propos des sites',
  'property-info.special-emergencies': 'Urgences',
  'property-info.gallery': 'Galerie',
  'property-info.policies': 'Stratégies',
  'property-info.nearby': 'Proche',
  'property-info.transport': 'Transport',
  'property-info.location': 'Emplacement',
  'property-info.about-rhproperty': 'À propos de la maison de retraite',
  'property-info.related-topics': 'Rubriques connexes',
  'property-info.assistant-options': "Options de l'assistant",
  'property-info.restaurant-assistant-information':
    'Informations sur les restaurants',
  'property-info.restaurant-assistant-options': 'Message de bienvenue',
  'property-info.channel-messages': 'Messages de canal',
  'property-info.icon.gallery': "Galerie d'icônes",
  'property-info.copilot': 'Copilote',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Informations sur la maison',
  'property-info.loction': 'Emplacements',
  'property-info.rooms-and-images': 'Chambres & Images',
  'property-info.trainig-data': "Données d'entraînement",
  'property-info.flows': 'Les flux',
  'property-info.add-your-own': 'Ajouter votre propre',
  'property-info-utility-miscellaneous': 'Divers',
  'property-info-utility-payment': 'Paiements',
  'property-info-utility-broadband': 'Haut débit',
  'property-info-utility-emergency': 'Urgence',
  'property-info-utility-mobile': 'Mobile',
  'property-info-utility-moving': 'En mouvement',
  'property-info.publishMonitor': 'Publier et surveiller',
  'property-info.webWidget': 'Widget Web',
  'property-info.media': 'Médias',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Plans tarifaires',
  'rate-promo.rate-plan-addons': 'Modules complémentaires',
  'rate-promo.rate-plan-promos': 'Promos',

  'title.property-information': 'Informations sur la propriété',

  'property.message': 'Un message',
  'property.example': 'Exemple',
  'property.link': 'Liens',
  'property.image-carousel': "Carrousel d'images",
  'property.Title': 'Titre',
  'property.SubTitle': 'Sous-titre',

  'property.add-invoke-api': 'Invoquer l`API',
  'property.add-message-button': 'Ajouter des messages',
  'property.add-img-button': 'Ajouter des images',
  'property.add-link-button': 'Ajouter un lien',
  'property.add-herocard-button': 'Ajouter une carte de héros',
  'property.add-api-button': 'Ajouter des boutons',

  'menu.settings': 'Paramètres',
  'menu.workflows': 'Flux de travail',
  'menu.product_services': 'Produits et services',
  'menu.product_recommander': 'Recommandeur de produits',
  'menu.digital_guide_book': 'Guide numérique',
  'menu.welcome_message': 'Message de bienvenue',
  'menu.about-property': 'À propos de la propriété',
  'menu.property-facilities': 'Équipements de la propriété',
  'menu.room-amenities': 'Commodités de la chambre',
  'menu.property-contact': 'Contact de la propriété',
  'menu.about-rooms': 'Chambres',
  'menu.special-emergencies': 'Urgences',
  'menu.show-filter': 'Filtres',
  'menu.new': 'Nouveau',
  'menu.channel': 'Canaux',
  'menu.application': 'Applications',

  'dashboards.send': 'Envoyer',
  'dashboards.hello': 'Bonjour',
  'dashboards.notificationsAllowed': 'Notifications autorisées',
  'dashboards.allowNotifications': 'Autoriser les notifications',
  'dashboards.views': 'Vues',
  'dashboards.bookingURL': 'URL de réservation',
  'dashboards.searchTags': 'Étiquettes de recherche',
  'dashboards.searchCategoryTags': 'Étiquettes de catégorie de recherche',
  'dashboards.bedroom': 'Chambre',
  'dashboards.addBedroom': 'Ajouter une chambre',
  'dashboards.frequency': 'Fréquence',
  'dashboards.includeSubpages': 'Inclure les sous-pages',
  'dashboards.enableFaqs': 'Activer les FAQ',
  'dashboards.faqsDescription': 'L’activation des FAQ vous permet de saisir des questions pendant que le système extrait les réponses correspondantes du contenu de la page Web pour créer des FAQ complètes',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Supprimer le document',
  'dashboards.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
  'dashboards.addItem': 'Ajouter un élément',
  'dashboards.addFirstWebPage': 'Ajoutez votre première page Web',

  'dashboards.popular-compendium': 'Éléments populaires du menu du compendium',
  'dashboards.wordcloudofcompendium': 'Nuage de mots des éléments du menu du compendium',
  'dashboards.wordcloudonthings': 'Nuage de mots sur ce que les visiteurs du site demandent et les éléments du menu',
  'dashboards.common-asked': 'Questions fréquemment posées',
  'dashboards.website-visitor-asking':
    'Ce que les visiteurs du site Web demandent',
  'dashboards.visit-country': 'Visite du site Web par pays',
  'dashboards.visit-traffic': 'Pays du trafic du site Web',
  'dashboards.rooms-product': 'Chambres & Produits',
  'dashboards.popular-room-product': 'Chambres et produits populaires',

  'dashboards.messenger-stats': 'Éléments de menu populaires',
  'dashboards.messenger-stats-topic-view':
    'Statistiques sur les vues des éléments de menu',
  'dashboards.messenger-stats-visits': 'Vues des éléments de menu',
  'dashboards.opening-menu-items':
    'Nombre de visiteurs du site Web ouvrant des éléments de menu',
  'dashboards.tickets-by-category': 'Tickets par catégorie',
  'dashboards.download': 'Télécharger',
  'dashboards.number-totalavatarclick': "Nombre total de clics sur l'avatar",
  'dashboards.subscribe-to-reports': 'Abonnez-vous aux rapports',
  'dashboards.clicks': 'Clics',
  'dashboards.leads': 'Fils',
  'dashboards.hours': 'Heures',
  'dashboards.minutes': 'Minutes',

  'dashboards.ai-chatbot': 'Chatbot IA',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'Utilisation du recueil numérique',
  'dashboards.compendium-unique-visits': 'Scans/clics de codes QR',
  'dashboards.compendium-opening-menu-items':
    'Nombre d`éléments de menu consultés',
  'dashboards.compendium-total-digital-clicks':
    'Nombre total de vues des éléments de menu',
  'dashboards.compendium-total-qr-code': 'Nombre total de scans/clics de codes QR',
  'dashboards.compendium-avg-menu-items': 'Nombre moyen de vues des éléments de menu par analyse',


  'property.delete': 'Effacer',
  'menu.userroles': 'Utilisateurs et rôles',
  'menu.members': 'Membres',
  'menu.guest-pass': 'Pass invité',
  'menu.ratebookings': 'Tarifs & Réservations',
  'dashboards.engagement-time': "Temps d'engagement de l'assistant numérique",
  'dashboards.conversations-minutes':
    'Nombre total de minutes et nuit (de 19h à 7h) Minutes de conversations',
  'dashboards.visitor-questions': 'Questions des visiteurs',
  'dashboards.recent-queries': 'Requêtes récentes',
  'dashboards.visitor-saying':
    "Ce que vos visiteurs disent à l'assistant numérique",
  'dashboards.contacts-prechatform-leavemessage':
    'Contacts stockés à partir du formulaire de pré-chat et laisser un message',
  'menu.dashboards': 'Connaissances',
  'menu.ari': 'Disponibilité et tarifs',
  'menu.conversations': 'Des conversations',
  'menu.conversations.unified-inbox': 'Boîte de réception unifiée',
  'menu.conversations.active': 'Discussions actives',
  'menu.conversations.archives': 'Les archives',
  'menu.conversations.missed-responses': 'Réponses manquées',
  'menu.conversations.ticket': 'Des billets',
  'menu.conversations.reply-templates': 'Modèles de réponse',
  'menu.bookings': 'Réservations et réservations',
  'menu.tickets': 'Leads et billets',
  'menu.propinfo': 'Centre de connaissances',
  'menu.rate-promos': 'Tarifs et promotions',
  'menu.finance': 'La finance',
  'menu.integration': 'Relier',
  'menu.admin': 'Admin et sécurité',
  'menu.favourites': 'Favoris',
  'menu.recommender': 'Flux de conversation',
  'menu.assistant-setup': `Configuration de l'assistant`,
  'menu.admin-insights': 'Informations sur l`administrateur',
  'menu.super-admin': 'Super administrateur',
  'menu.groups': 'Groupes',
  'menu.properties': 'Propriétés',
  'menu.service-provider': 'Fournisseurs de services',
  'menu.spaces': 'Espaces',
  'menu.content-manager': 'Gestionnaire de contenu',
  'menu.events-calendar': 'Calendrier des événements',
  'menu.appearance-settings': 'Apparence et paramètres',
  'menu.availability': '	Disponibilité',
  'menu.help': 'Aide',
  'menu.myAccounts': 'Mes comptes',

  'dashboards.space-booking': 'Réservation d`espace',
  'dashboards.gift-voucher': 'Chèques cadeaux',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'Depuis',
  'dashboards.to': 'À',
  'dashboards.active-groups': 'Groupes actifs',
  'dashboards.active-properties': 'Propriétés actives',
  'dashboards.live-properties': 'Propriétés en direct',
  'dashboards.properties-going': 'Propriétés mises en ligne par plage de dates',
  'dashboards.start-date': 'Date de début',
  'dashboards.end-date': 'Date de fin',

  'dashboards.website-visits': 'Visites du site Web',
  'dashboards.unique-visitors': 'visiteurs uniques',
  'dashboards.last-week': 'La semaine dernière',
  'dashboards.this-week': 'Cette semaine',
  'dashboards.this-month': 'Ce mois-ci',
  'dashboards.previous-month': 'Le mois précédent',
  'dashboards.yeartodate': 'Année à ce jour',
  'dashboards.lastyear': "L'année dernière",
  'dashboards.last-7-days': 'Les 7 derniers jours',
  'dashboards.last-30-days': 'Les 30 derniers jours',
  'dashboards.last-60-days': 'Les 60 derniers jours',
  'dashboards.last-90-days': 'Les 90 derniers jours',
  'dashboards.conversion-rates': 'Taux de conversion',
  'dashboards.digital-assistant-engagement':
    "Engagement de l'assistant numérique",
  'dashboards.total-overnight-conversations':
    'Conversations totales et de nuit (19h à 7h)',
  'dashboards.percentage-accuracy': 'Comprendre la précision',
  'dashboards.percentage-conversion':
    'Trafic du site Web en conversion de chat',
  'dashboards.percentage-avatarclick':
    'Trafic du site Web vers les clics d’avatar',
  'dashboards.percentage-negativefeedback':
    'Commentaires négatifs en pourcentage des clics sur l`avatar',
  'dashboards.percentage-amenties': "Requêtes d'agrément",
  'dashboards.percentage-booking': 'Demandes de réservation',
  'dashboards.percentage-webchats': 'Chats sur le site Web',
  'dashboards.percentage-facebookchat': 'Chats Facebook',
  //'dashboards.number-webchattime': 'Durée totale du chat Web',
  'dashboards.name': 'Nom',
  'dashboards.button': 'Bouton',
  'dashboards.visits': 'Visites',
  'dashboards.checkAvailability': 'Vérifier la disponibilité ou les tarifs',
  'dashboards.details': 'Détails',
  'dashboards.number-webchattime': 'Temps total de conversation',
  'dashboards.number-totalconversation': 'Conversations totales',
  'dashboards.number-websiteconversation': 'Conversations sur le site Web',
  'dashboards.number-facebookconversation': 'Conversations sur Facebook',
  'dashboards.number-estimatedtimesaving': 'Gain de temps estimé',
  'dashboards.number-googlemapsconversation': 'Conversation Google Maps',
  'dashboards.number-whatsappconversation': 'Conversations WhatsApp',
  'dashboards.number-instagramconversation': 'Conversations sur Instagram',
  'dashboards.number-agentconversation': 'Conversations avec les agents',
  'dashboards.number-amenityqueries': "Demandes d'agrément",
  'dashboards.number-bookingenquiries': 'Demandes de réservation',
  'dashboards.number-groupbookingenquiries':
    'Demandes de réservation de groupe',
  'dashboards.number-eventenquiries': "Demandes d'événements",
  'dashboards.number-longstayenquiries': 'Demandes de long séjour',
  'dashboards.number-totaltickets': 'Des billets',
  'dashboards.number-returncustomer': 'Client de retour',
  'dashboards.number-redirects': 'Redirections de site Web',
  'dashboards.number-bookingengineleads': 'Moteur de réservation',
  'dashboards.number-roomnightsreferred': 'Nuitées Référées',
  'dashboards.number-revenuereferred': 'Revenu référé',
  'menu.bookingsmenu': 'Réservations',
  'menu.guests': 'Informations client',
  'menu.whatsnew': 'Quoi de neuf',
  'dashboards.welcomeMessage': 'Message de bienvenue',
  'dashboards.personalizeGreeting': 'Personnalisez la manière dont les clients sont accueillis pour refléter votre marque, votre style et votre étiquette, afin qu’ils reçoivent le meilleur accueil. Personnalisez les salutations pour refléter votre marque et offrir un accueil chaleureux.',
  'dashboards.addRoomDetails': 'Ajoutez des détails sur chacune de vos chambres afin que les clients puissent facilement découvrir tout ce dont ils ont besoin pour choisir l’option parfaite et rendre le processus de réservation plus simple et plus rapide.',
  'dashboards.trainAIFAQs': 'Entraînez l’IA avec les FAQ',
  'dashboards.manualQuestions': 'Certaines questions ne peuvent pas être répondues par des documents ou trouvées sur le site. Ici, vous pouvez ajouter manuellement des questions pour vous assurer que les clients ont toujours les informations dont ils ont besoin à portée de main.',
  'dashboards.publishAI': 'Publier l’IA pour refléter les mises à jour les plus récentes',
  'dashboards.retrainAfterChanges': 'Lorsque vous apportez des modifications dans le Knowledge Hub ou aux formulaires, assurez‑vous de réentraîner le chatbot avec les informations mises à jour. Publier votre IA garantit que le chatbot fournit les réponses les plus précises et à jour.',
  'dashboards.enhanceKnowledge': 'Améliorez les connaissances de l’IA en suivant les requêtes sans réponse',
  'dashboards.reviewUnanswered': 'Chaque fois que l’IA ne peut pas répondre à une question ou n’apporte que des détails limités, vous trouverez ces requêtes ici. Passez-les en revue pour identifier les lacunes dans votre Knowledge Hub ou les questions uniques des clients.',
  'dashboards.manageMedia': 'Gérer les médias',
  'dashboards.mediaGallery': 'Chaque fois que vous téléchargez des images telles que des chambres, des commodités, des logos ou votre avatar numérique, elles apparaîtront dans cette galerie, vous offrant un lieu central pour gérer les visuels et garantir que vos clients voient ce qui rend votre entreprise unique.',
  'dashboards.createForms': 'Créez des formulaires facilement et recevez une notification à chaque soumission.',
  'dashboards.manageForms': 'Créez et gérez des formulaires pour collecter les informations des clients, configurer les notifications et les personnaliser pour différentes langues.',
  'dashboards.personalizeResponse': 'Personnalisez le style de réponse et la progression de la conversation',
  'dashboards.controlConversation': 'Cette fonctionnalité avancée vous donne la capacité de façonner et de contrôler la manière dont les conversations se déroulent avec vos clients sur différents canaux.',

  'forms.forms-title': 'Former',
  'menu.formbuilder': 'Générateur de formulaires',
  "dashboards.trainAI": "Entraînez l'IA avec des documents",
  "dashboards.uploadDocuments": "Téléchargez des documents pour aider votre IA à comprendre votre entreprise et à assister les clients comme vous le feriez. Vous pouvez ajouter des fichiers au format .doc, .pdf ou .txt.",
  'menu.virtualfrontdesk': 'Réception virtuelle',
  'menu.guestservice': 'Services à la clientèle',
  'virtual-front.common-questions': 'Questions courantes',
  'virtual-front.add-on-upsells': 'Add-on et ventes incitatives',
  'virtual-front.service-order': 'Demande de service',
  //'virtual-front.guest-service-add-on-upsells': "Services aux invités et modules complémentaires",
  'virtual-front.guest-service-add-on-upsells': "Livre d'or numérique",
  'virtual-front.outbound': 'Sortant',
  'virtual-messenger': 'Messagère',

  'missed-response.missed-response-title': 'Titre de la réponse manquée',

  //unified inbox
  'content.allconversation': 'Toutes les conversations',
  'content.active': 'Actif',
  'content.tickets': 'Tickets',
  'content.filter': 'Filtrer',
  'content.createtickets': 'Créer des tickets',
  'content.conversation': 'Conversation',
  'content.knowledgesearch': 'Recherche de connaissances',
  'content.reply': 'Répondre',
  'content.visitorinfo': 'Infos visiteur',
  'content.callinfo': 'Infos appel',
  'content.allinsights': 'Toutes les analyses',
  'content.availabilityrates': 'Disponibilité et tarifs',
  'content.callback': 'Rappel',
  'content.close': 'Fermer',
  'content.sms': 'SMS',
  'content.timestamp': 'Horodatage',
  'content.topics': 'Sujets',
  'content.callingparty': 'Appelant',
  'content.accountdomain': 'Domaine du compte',
  'content.calledparty': 'Appelé',
  'content.recording': 'Enregistrement',
  'content.phonesystemoriginationcallid': 'ID d’appel d’origine du système téléphonique',
  'content.phonesystemterminationcallid': 'ID d’appel de fin du système téléphonique',
  'content.uniqueconversationid': 'ID unique de conversation',
  'content.regenerateinsights': 'Régénérer les analyses',
  'content.customersentiment': 'Sentiment client',
  'content.neutral': 'Neutre',
  'content.customerreportedbroadbandoutage': 'Le client a signalé une panne de la connexion haut débit en fournissant son identifiant client et la date d’activation du service pour obtenir de l’aide.',
  'content.conversationinsights': 'Analyses de la conversation',
  'content.broadbandoutage': 'Panne de la connexion haut débit',
  'content.customeridverification': 'Vérification de l’ID client',
  'content.serviceactivationdate': 'Date d’activation du service',
  'content.followups': 'Suivis',
  'content.actionneeded': 'Action requise',
  'content.uniqueConversationId': 'ID de conversation unique',
  'content.uniqueChatId': 'ID de chat unique',
  'content.recording&transcript': 'Enregistrement & Transcription',
  'content.chatinsights': 'Aperçus du chat',
  'content.visitedpages': 'Pages visitées',
  'content.deviceinfo': 'Infos appareil',
  'content.chatstartedonthispage': 'Discussion démarrée sur cette page',
  'content.prechatinfo': 'Infos pré‑chat',
  'content.notes': 'Notes',
  'content.reassign': 'Réattribuer',
  'content.open': 'Ouvrir',



  /* Missed Response */
  'feedback.missed-question': 'Question manquée',
  'feedback.conversation-summary': 'Résumé de la conversation',
  'feedback.dates-in-spanish': 'Les dates doivent être en espagnol',
  'feedback.resolve': 'Résoudre',
  'feedback.ignore': 'Ignorer',

  // Integration
  'integration.select_properties': 'Sélectionner les propriétés',
  'integration.select_properties_enabled': 'Sélectionner les propriétés activées via cette intégration',
  'integration.services_addons': 'Sélectionner les services & modules complémentaires',
  'integration.services_visible': 'Sélectionner les services & modules complémentaires visibles sur cette page',
  'integration.appearance': 'Apparence',
  'integration.appearance_customize': 'Choisissez le nom de votre assistant numérique, l’avatar et configurez vos couleurs',
  'integration.booking_calendar': 'Calendrier de réservation',
  'integration.booking_calendar_style': 'Choisissez le style du pop‑up du calendrier de réservation',
  'integration.nudges': 'Incitations',
  'integration.nudges_setup': 'Configurez des messages proactifs pour engager les visiteurs du site',
  'integration.position': 'Position',
  'integration.position_control': 'Contrôlez la position du widget de chat sur votre site',
  'integration.custom_fonts': 'Polices personnalisées',
  'integration.custom_fonts_upload': 'Téléchargez des polices personnalisées à utiliser sur la page',
  'integration.custom_css': 'CSS personnalisé',
  'integration.custom_css_usage': 'Utilisez du CSS pour personnaliser votre Compendium Numérique',
  'integration.location': 'Emplacement',
  'integration.location_embed': 'Ajoutez votre URL d’intégration',
  'integration.external_links': 'Liens externes',
  'integration.external_links_add': 'Ajoutez vos liens',
  'integration.language': 'Langue',
  'integration.widget_languages': 'Sélectionnez les langues pour le widget de chat',
  'integration.chatbot_contact': 'Chatbot',
  'integration.chatbot_enable': 'Activez votre assistant numérique',
  'integration.chatbot_security': 'Gardez votre messagerie sécurisée',
  'integration.chatbot_trusted_pages': 'Listez vos pages de confiance pour afficher le Chatbot',
  'integration.chatbot_publish': 'Publiez votre assistant numérique',
  'integration.chatbot_install': 'Copiez le snippet de code pour installer votre assistant numérique',


};
export default chMessages;